
<!-- Navbar -->
<app-navbar-style-two></app-navbar-style-two>

<div class="container-fluid product-page px-3 px-md-4">

    <div class="row">

        <!-- Category Sidebar -->
        <div class="col-12 col-lg-3 col-xl-2 category-section">

            <!-- Mobile Category Toggle -->
            <div class="category-toggle d-lg-none">

                <button class="btn btn-outline-primary w-100"
                        type="button"
                        (click)="toggleSidebar()">

                    <i class="bx bx-menu"></i>
                    Browse Categories

                </button>

            </div>

            <!-- Mobile Sidebar -->
            <div *ngIf="isSidebarVisible"
                 class="mobile-sidebar d-lg-none">

                <ul class="list-group">

                    <li class="list-group-item list-group-item-action"
                        *ngFor="let category of categories"
                        (click)="filterProductsByCategory(category.name); toggleSidebar()"
                        [class.active]="category.name === selectedCategory">

                        {{ category.name }}

                    </li>

                </ul>

            </div>

            <!-- Desktop Sidebar -->
            <div class="desktop-sidebar d-none d-lg-block">

                <ul class="list-group">

                    <li class="list-group-item list-group-item-action"
                        *ngFor="let category of categories"
                        (click)="filterProductsByCategory(category.name)"
                        [class.active]="category.name === selectedCategory">

                        {{ category.name }}

                    </li>

                </ul>

            </div>

        </div>


        <!-- Products Section -->
        <div class="col-12 col-lg-9 col-xl-10">

            <div class="products-list">

                <div class="row g-3 g-md-4">

                    <div class="col-12 col-sm-6 col-xl-4 col-xxl-3"
                         *ngFor="let Content of paginatedProducts">

                        <div class="single-products-item border rounded shadow-sm h-100">

                            <!-- Product Image -->
                            <div class="products-image">

                                <a [routerLink]="['/product', Content.keywords]"
                                   class="product-image-link">

                                    <img [src]="Content.mainImg"
                                         [alt]="Content.title"
                                         class="img-fluid rounded">

                                </a>

                                <!-- Product Icons -->
                                <ul class="products-button list-unstyled">

                                    <!-- View Icon -->
                                    <li>

                                        <a [routerLink]="['/product', Content.keywords]"
                                           title="View Product">

                                            <i class="bx bx-show-alt"></i>

                                        </a>

                                    </li>

                                    <!-- Lens / Zoom Icon -->
                                    <li>

                                        <a [href]="Content.mainImg"
                                           class="popup-btn"
                                           title="Zoom Image">

                                            <i class="bx bx-scan"></i>

                                        </a>

                                    </li>

                                    <!-- Link Icon -->
                                    <li>

                                        <a [routerLink]="['/product', Content.keywords]"
                                           title="Product Details">

                                            <i class="bx bx-link"></i>

                                        </a>

                                    </li>

                                </ul>

                            </div>


                            <!-- Product Details -->
                            <div class="products-content text-center">

                                <h3>

                                    <a [routerLink]="['/product', Content.keywords]">

                                        {{ Content.title }}

                                    </a>

                                </h3>

                                <!-- Product Price -->
                                <div class="price">

                                    <span class="new-price text-success font-weight-bold">

                                        {{ Content.newPrice }}

                                    </span>

                                    <span class="old-price text-danger text-decoration-line-through"
                                          *ngIf="Content.oldPrice">

                                        {{ Content.oldPrice }}

                                    </span>

                                </div>

                            </div>


                            <!-- Product Status -->
                            <div class="product-status text-center">

                                <span class="badge badge-warning"
                                      *ngIf="Content.sale">

                                    {{ Content.sale }}

                                </span>

                                <div class="text-danger font-weight-bold"
                                     *ngIf="Content.outOfStock">

                                    {{ Content.outOfStock }}

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>


            <!-- No Products Found -->
            <div class="no-results-found text-center mt-4"
                 *ngIf="paginatedProducts.length === 0">

                No results found.

            </div>


            <!-- Pagination -->
            <div class="pagination d-flex justify-content-center align-items-center flex-wrap mt-4">

                <button class="btn btn-primary mx-2 mb-2"
                        (click)="previousPage()"
                        [disabled]="currentPage === 1">

                    Previous

                </button>

                <span class="font-weight-bold mx-2 mb-2">

                    Page {{ currentPage }} of {{ totalPages }}

                </span>

                <button class="btn btn-primary mx-2 mb-2"
                        (click)="nextPage()"
                        [disabled]="currentPage === totalPages">

                    Next

                </button>

            </div>

        </div>

    </div>

</div>
